import WithdrawalError from 'pages/Withdrawal/WithdrawalError';
import WithdrawalLookup from 'pages/Withdrawal/WithdrawalLookup';
import WithdrawalSelection from 'pages/Withdrawal/WithdrawalSelection';
import WithdrawalSuccess from 'pages/Withdrawal/WithdrawalSuccess';
import { Navigate, Route, Routes } from 'react-router-dom';
import { WITHDRAWAL_ROUTES } from 'utils/withdrawalRoutes';
import WithdrawalLayout from './WithdrawalLayout';

const WithdrawalRoutes = () => (
    <WithdrawalLayout>
        <Routes>
            <Route path={WITHDRAWAL_ROUTES.lookup} element={<WithdrawalLookup />} />
            <Route path={WITHDRAWAL_ROUTES.selection} element={<WithdrawalSelection />} />
            <Route path={WITHDRAWAL_ROUTES.success} element={<WithdrawalSuccess />} />
            <Route path={WITHDRAWAL_ROUTES.error} element={<WithdrawalError />} />
            <Route path="*" element={<Navigate to={WITHDRAWAL_ROUTES.lookup} replace />} />
        </Routes>
    </WithdrawalLayout>
);

export default WithdrawalRoutes;
